/** biome-ignore-all lint/correctness/useUniqueElementIds: <explanation> */
import type React from 'react';

export interface ToggleOnThumbIconProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	'aria-label'?: string;
}

const ToggleOnThumbIcon: React.FC<ToggleOnThumbIconProps> = ({
	width = 25,
	height = 24,
	fill = 'currentColor',
	'aria-label': ariaLabel = 'Toggle On Thumb Icon',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 25 24"
			fill={fill}
			xmlns="http://www.w3.org/2000/svg"
			aria-label={ariaLabel}
		>
			<title>Toggle On Thumb Icon</title>
			<rect x="0.245605" y="0.5" width="24" height="24" rx="12" fill="white" />
			<path
				d="M12.2456 14.9997C12.9401 14.9997 13.5303 14.7566 14.0164 14.2705C14.5026 13.7844 14.7456 13.1941 14.7456 12.4997C14.7456 11.8052 14.5026 11.215 14.0164 10.7288C13.5303 10.2427 12.9401 9.99967 12.2456 9.99967C11.5512 9.99967 10.9609 10.2427 10.4748 10.7288C9.98867 11.215 9.74562 11.8052 9.74562 12.4997C9.74562 13.1941 9.98867 13.7844 10.4748 14.2705C10.9609 14.7566 11.5512 14.9997 12.2456 14.9997ZM12.2456 16.6663C11.0928 16.6663 10.1101 16.26 9.29728 15.4472C8.4845 14.6344 8.07839 13.6519 8.07895 12.4997C8.07895 11.3469 8.48534 10.3641 9.29812 9.55134C10.1109 8.73856 11.0934 8.33245 12.2456 8.33301C13.3984 8.33301 14.3812 8.7394 15.1939 9.55218C16.0067 10.365 16.4128 11.3475 16.4123 12.4997C16.4123 13.6525 16.0059 14.6352 15.1931 15.448C14.3803 16.2608 13.3978 16.6669 12.2456 16.6663ZM6.41228 13.333H3.07895V11.6663H6.41228V13.333ZM21.4123 13.333H18.0789V11.6663H21.4123V13.333ZM11.4123 6.66634V3.33301H13.0789V6.66634H11.4123ZM11.4123 21.6663V18.333H13.0789V21.6663H11.4123ZM7.57895 8.95801L5.47478 6.93717L6.66228 5.70801L8.66228 7.79134L7.57895 8.95801ZM17.8289 19.2913L15.8081 17.1872L16.9123 16.0413L19.0164 18.0622L17.8289 19.2913ZM15.7873 7.83301L17.8081 5.72884L19.0373 6.91634L16.9539 8.91634L15.7873 7.83301ZM5.45395 18.083L7.55812 16.0622L8.70395 17.1663L6.68312 19.2705L5.45395 18.083Z"
				fill="url(#paint0_linear_2989_20619)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_2989_20619"
					x1="12.2456"
					y1="3.33301"
					x2="12.2456"
					y2="21.6663"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#195670" />
					<stop offset="1" stopColor="#117964" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ToggleOnThumbIcon;
